import React, { useEffect, useState } from "react";
import LoadingScreen from "../../components/LoadingScreen";

const defaultAuth = {
    token: null,
    platformUser: null,
    postToken: null,
    ticketUuid: null,
    serviceType: null,
    returnUrl: null,
};

export const DivarAuthContext = React.createContext({
    ...defaultAuth,
    loading: true, // Add loading to context default
});

const DivarAuthProvider = ({ children }) => {
    const [auth, setAuthState] = useState(defaultAuth);
    const [loading, setLoading] = useState(true); // New loading state

    useEffect(() => {
        const token = sessionStorage.getItem('token');
        const postToken = sessionStorage.getItem('post_token');
        const ticketUuid = sessionStorage.getItem('ticket_uuid');
        const serviceType = sessionStorage.getItem('service_type');
        const returnUrl = sessionStorage.getItem('return_url');
        const platformUser = sessionStorage.getItem('platformUser');

        const storedAuth = {
            token: token || null,
            postToken: postToken || null,
            ticketUuid: ticketUuid || null,
            serviceType: serviceType || null,
            returnUrl: returnUrl || null,
            platformUser: platformUser ? JSON.parse(platformUser) : null,
        };

        setAuthState(storedAuth);
        setLoading(false); // Done loading
    }, []);

    return (
        <DivarAuthContext.Provider value={{ ...auth, loading }}>
            {loading ? <LoadingScreen/> : children}
        </DivarAuthContext.Provider>
    );
};

export default DivarAuthProvider;
